import { Component, HostListener, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AppConfigService } from '../app-config.service';
import { MatDialogConfig, MatDialog } from "@angular/material/dialog";
import { CommonService } from '../common.service';
import { Router } from '@angular/router';
import { LoginPopupComponent } from '../login/login-popup/login-popup.component';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-web-viewer-frame',
  templateUrl: './web-viewer-frame.component.html',
  styleUrls: ['./web-viewer-frame.component.css']
})
export class WebViewerFrameComponent implements OnInit {
  /* @HostListener('window:focus', ['$event'])
  appVisibility() {
    this.fetchParentLoginToken();
  } */

  urlSafe: SafeResourceUrl = '';
  id: string = '';
  viewerSlides: any = [];
  appConfig: any = {};

  constructor(private sanitizer: DomSanitizer,
    private appConfigService: AppConfigService,
    private dialog: MatDialog,
    private router: Router,
    private authService: AuthService,
    private commonService: CommonService) {
    this.appConfig = this.appConfigService.config;
    const msgEvent = (event: any) => {
      if ((event?.data?.call == 'parentComponent') && event?.data?.value?.fetchSlideInfo) {
        if (event?.data?.value?.fetchSlideInfo) {
          this.commonService.fetchProjectLSData();
        }
        this.sendDataToViewer(event?.data?.value?.postMessageCall);
      } else if (event?.data?.call == 'showStudyDetails') {
        this.openStudyDetailDialog(event?.data?.value?.slideGUID);
      } else if (event?.data?.call == 'viewerInitialized') {
        this.commonService.ProjectLSData['isViewerInitialized'] = true;
        this.commonService.setProjectLSData();
      } else if (event?.data?.call == 'updateViewerInfo') {
        let slidesInfo: any = event?.data?.value?.slidesInfo;
        this.commonService.ProjectLSData['ViewerSlides'] = slidesInfo;
        this.commonService.setProjectLSData();
      } else if (event?.data?.call == 'openImageInSameViewer') {
        let slidesInfo: any = event?.data?.value?.slidesInfo;
        this.commonService.ProjectLSData['ViewerSlides'] = slidesInfo;
        if (event?.data?.value?.mrnId) {
          this.commonService.ProjectLSData['MRNID'] = event.data.value.mrnId;
        }
        this.commonService.setProjectLSData();
        this.updateViewerImage('updateViewerImageInfo', {
          ViewerSlides: this.commonService.ProjectLSData['ViewerSlides']
        });

      } else if (event?.data?.call == 'compareImageViewerUpdate') {
        let slidesInfo: any = event?.data?.value?.slidesInfo;
        let isSelfCompare = event?.data?.value?.isSelfCompare;
        // for self compare, there is no need to store duplicate entries for a slide, only store the entry for primary image in viewer slides
        this.commonService.ProjectLSData['ViewerSlides'] = isSelfCompare ? [slidesInfo[0]] : slidesInfo;
        if (event?.data?.value?.mrnId) {
          this.commonService.ProjectLSData['MRNID'] = event.data.value.mrnId;
        }
        this.commonService.setProjectLSData();
        this.updateViewerImage('updateCompareViewerImageInfo', {
          ViewerSlides: slidesInfo,
          slideIds: event?.data?.value?.slideIds,
          viewerUpdateInfo: event?.data?.value?.viewerUpdateInfo
        });
        /* } else if (event?.data?.call == 'compareImage') {
          let slidesInfo: any = event?.data?.value?.slidesInfo;
          this.commonService.ProjectLSData['ViewerSlides'] = slidesInfo;
          if (event?.data?.value?.mrnId) {
            this.commonService.ProjectLSData['MRNID'] = event.data.value.mrnId;
          }
          this.commonService.setProjectLSData();
          this.updateViewerImage('addImageToViewerForCompare', { ViewerSlides: this.commonService.ProjectLSData['ViewerSlides'], slideIds: event?.data?.value?.slideIds }); */
        /* } else if (event?.data?.call == 'compareImage1') {
          let slidesInfo: any = event?.data?.value?.slidesInfo;
          this.commonService.ProjectLSData['ViewerSlides'] = slidesInfo;
          if (event?.data?.value?.mrnId) {
            this.commonService.ProjectLSData['MRNID'] = event.data.value.mrnId;
          }
          this.commonService.setProjectLSData();
          // let slideIds: any = event?.data?.value?.slideIds;
          // this.router.navigate(['WebViewer/' + slideIds.toString()]).then(() => {
          this.router.navigate(['WebViewer']).then(() => {
            this.sendDataToViewer();
          }); */
      } else if (event?.data?.call == 'storeToken') {
        this.authService.storeTokens(event?.data?.value);
      } else if (event?.data?.call == 'reLogin') {
        this.reLogin();
      } else if (event?.data?.call == 'fetchParentLoginToken') {
        this.fetchParentLoginToken();
      } else if (event?.data?.call == 'moveToGallery') {
        window.removeEventListener("message", msgEvent, false);
        if (this.appConfig.openViewer == "popup") {
          window.close();
          /* if (this.commonService.webViewerWindow && !this.commonService.webViewerWindow.closed) {
            this.commonService.webViewerWindow.close();
          } */
        } else {
          // this.router.navigate(['/mainboard/patient-data/' + elem["id"]]);
          this.router.navigate([this.commonService.ProjectLSData.LastParentAppUrl.replace(this.appConfig.parentAppUrl + this.appConfig.replacePathName, '')]);
        }
      } else if (event?.data?.call === 'slideReviewStatusChanged') {
        let viewerSlides = this.commonService.ProjectLSData['ViewerSlides'];
        let slideIndex = viewerSlides.findIndex((slide: any) => slide.id === event.data.value.slideId);
        if (slideIndex !== -1) {
          this.commonService.ProjectLSData['ViewerSlides'][slideIndex] = { ...event.data.value.slideInfo };
          this.commonService.setProjectLSData();
        }
      }
    }
    window.addEventListener("message", msgEvent, false);
  }

  ngOnInit(): void {
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.appConfig.webViewerUrl);
  }

  reLogin() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = "20%";
    dialogConfig.panelClass = 'reLoginPopup';
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      headerTitle: "Login",
      confirmMsg: "Session expired. Login again to continue",
      cancelButtonText: "Cancel",
      confirmButtonText: "Yes",
      isAccessTokenExpired: true
    };
    const dialogref = this.dialog.open(LoginPopupComponent, dialogConfig);
    return dialogref.afterClosed().subscribe((result: any) => {
      if (result && result.loginStatus == "success") {
        let reLoginObj: any = {
          accessToken: this.authService.getAccessToken(),
          refreshToken: this.authService.getRefreshToken(),
          sessionId: this.authService.getSessionId()
        };
        let iframe: any = document.getElementById('webViewerFrame');
        iframe['contentWindow'].postMessage({
          call: 'reLoginSuccess', value: reLoginObj
        }, this.appConfig.webViewerUrl);
      }
    });
  }

  updateViewerImage(iFrameCall: any, callValue: any) {
    let iframe: any = document.getElementById('webViewerFrame');
    iframe['contentWindow'].postMessage({
      call: iFrameCall, value: callValue
    }, this.appConfig.webViewerUrl);
  }

  fetchParentLoginToken() {
    console.log("fetchParentLoginToken");
    if (localStorage[this.commonService.projectName]) {
      this.commonService.ProjectLSData = JSON.parse(localStorage[this.commonService.projectName]);
    }
    let fetchParentLoginTokenObj: any = {
      accessToken: this.commonService.ProjectLSData.accessToken,
      refreshToken: this.commonService.ProjectLSData.refreshToken,
      sessionId: this.commonService.ProjectLSData.sessionId
    };
    let iframe: any = document.getElementById('webViewerFrame');
    iframe['contentWindow'].postMessage({
      call: 'fetchParentLoginTokenSuccess', value: fetchParentLoginTokenObj
    }, this.appConfig.webViewerUrl);
  }

  sendDataToViewer(postMessageCall: any = null) {
    /* let viewerSlidesIds = location.pathname.slice((location.pathname.lastIndexOf("/") + 1), location.pathname.length).split(",");
    this.viewerSlides = viewerSlidesIds.map((indvId) => {
      return { id: indvId }
    }); */
    let iframe: any = document.getElementById('webViewerFrame');
    if (iframe == null) return;
    let windowObj = {
      parentProj: this.commonService.projectName,
      viewerOpenedFrom: this.commonService.ProjectLSData['viewerOpenedFrom'] ? this.commonService.ProjectLSData['viewerOpenedFrom'] : 'gallery',
      activeRole: this.commonService.ProjectLSData['userActiveRole'],
      galleryFilter: [],
      loginUrl: this.appConfig.parentAppUrl,
      parentInfo: {},
      viewerBaseName: this.appConfig.webViewerBaseName,
      mrnId: this.commonService.ProjectLSData['MRNID'],
      mrnStatus: this.commonService.ProjectLSData['MRNStatus'],
      urlParent: {
        "apiUrl": this.appConfig.apiUrl,
        "thumbnailUrl": this.appConfig.thumbnailUrl,
        "tileUrl": this.appConfig.tileUrl
      },
      viewerSlides: this.commonService.ProjectLSData['ViewerSlides'],
      WebViewerOpenType: this.appConfig.openViewer,
      parentUrl: JSON.stringify(this.commonService.ProjectLSData['UrlApi']),
      lastParentAppUrl: this.commonService.ProjectLSData['LastParentAppUrl'],
      currentUser: this.commonService.ProjectLSData['currentUser'],

      accessToken: this.commonService.ProjectLSData['accessToken'],
      refreshToken: this.commonService.ProjectLSData['refreshToken'],
      sessionId: this.commonService.ProjectLSData['sessionId'],
      galleryFilteredValue: this.commonService.ProjectLSData["galleryFilteredValue"],
      gallerySearchedText: this.commonService.ProjectLSData["gallerySearchedText"]

    }

    iframe['contentWindow'].postMessage({
      call: (postMessageCall ? postMessageCall : 'webViewerFrame'), value: windowObj
    }, this.appConfig.webViewerUrl);
  }

  openStudyDetailDialog(slideGUID: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.disableClose = true;
    dialogConfig.width = "90%";
    dialogConfig.data = {
      showHeader: true,
      studyGuid: slideGUID
    };
    // this.dialog.open(StudyDetailsComponent, dialogConfig);
  }
}
